import { isNaN } from 'lodash-es';

export const isSourceKeyFormat = (val: string | number | undefined) => {
  return !!val && isNaN(Number(val));
};

/**
 * 返回小数部分
 * @param val
 * @returns
 */
export const getPrecisionValue = (val: number) => {
  const res = String(val).split('.');
  res[0] = '0';
  return Number(res.join('.'));
};

/**
 * 返回整数部分
 * @param val
 * @returns
 */
export const getIntValue = (val: number) => {
  const res = String(val).split('.');
  return Number(res[0]);
};

// 定义一个函数来提取样式名称中的数字部分
export const extractNumber = (str: string) => {
  const match = str.match(/\d+/); // 使用正则表达式匹配数字
  return match ? parseInt(match[0], 10) : 0; // 将匹配的数字转换为数字，如果没有匹配到则返回 0
};
